import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/site/Reveal";
import { API } from "@/lib/site";

export default function BlogTeaser() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts`).then((r) => setPosts(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="blog" data-testid="blog-teaser" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
                <BookOpen className="h-4 w-4" /> Blog & Panduan
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
                Tips terkini pinjaman perumahan
              </h2>
            </div>
            <Link to="/blog" data-testid="blog-teaser-all-btn">
              <Button variant="outline" className="rounded-full border-slate-300 text-[#0A2540] hover:bg-slate-50">
                Lihat semua artikel <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`teaser-card-${p.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-slate-200 overflow-hidden transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#1D4ED8]"
              >
                <div className="h-40 bg-slate-100 overflow-hidden">
                  <img
                    src={p.cover_image || "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-col flex-1 p-6">
                  <span className="flex items-center gap-1.5 text-xs text-slate-400">
                    <Calendar className="h-3.5 w-3.5" />
                    {new Date(p.created_at).toLocaleDateString("ms-MY", { year: "numeric", month: "long", day: "numeric" })}
                  </span>
                  <h3 className="mt-2 font-heading text-lg font-bold text-[#0A2540] leading-snug">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
